export default __webpack_public_path__ + "f8a3123ff74f7f83e2a2f4bf1bc4f91e.png";